<template>
    <div class="row">
      <!-- General Top Bar -->
      <!-- <general-top-bar :title="$t('pages.dispatch')"></general-top-bar> -->
      <!-- End General Top Bar -->
      <div class="box-container row tabs-dispatch">
        <div
            v-for="(route, index) in dispatchRoutes"
            :key="route.name"
            class="col-md-4"
        >
            <router-link
            :to="route.path"
            class="box"
            :style="{ backgroundColor: getBoxColor(index) }"
            >
            <div class="title">{{ $t('dispath.' + route.key) }}</div>
            <div class="image">
              <img :src="getImageForRoute(route.key)" :alt="'Image for ' + route.key" />
            </div>
            </router-link>
        </div>
       </div>
    </div>
</template>

  <script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'

  export default {
    components: {
      // GeneralTopBar
    },
    data () {
      return {
        dispatchRoutes: [
          { path: '/dispatch?tabIndex=0', key: 'dispatch' },
          { path: '/dispatch?tabIndex=1', key: 'addNewOrder' },
          { path: '/dispatch?tabIndex=2', key: 'drivers' },
          { path: '/dispatch?tabIndex=3', key: 'orders' },
          { path: '/dispatch?tabIndex=4', key: 'reports' },
          { path: '/dispatch?tabIndex=5', key: 'settings' }
        ]
      }
    },
    methods: {
      getImageForRoute (routeKey) {
        const images = {
          'dispatch': 'static/img/dispatch.png',
          'addNewOrder': 'static/img/dispatch-orders.png',
          'orders': 'static/img/dispatch-orders.png',
          'drivers': 'static/img/dispatch-drivers.png',
          'reports': 'static/img/dispatch-reports.png',
          'settings': 'static/img/dispatch-settings.png'
        }
        return images[routeKey] || 'static/img/default.jpg'
      },
      getBoxColor (index) {
        const colors = [
          '#3AB7CD', // First box
          '#17B086',
          '#674BD2',
          '#FF6B6B', // Third box
          '#FFD93D', // Fourth box
          '#17B086'  // Fifth box
        ]
        return colors[index] || '#FFFFFF' // Default color
      }
    }
  }
  </script>

  <style scoped>
  .box-container.row {
    max-width: 1300px;
    margin-top: 30px;
    margin: auto;
  }
  .tabs-dispatch{
    margin-top: 40px;
  }
  .box-container.row .image {
    position: absolute;
    bottom: 0;
  }
  .box-container .col-md-4 {
    width: 24.333333%;
  }
  .box {
    position: relative;
    margin-bottom: 30px;
    text-align: center;
    display: block;
    text-decoration: none;
    color: inherit;
    border-radius: 30px;
    width: 280px;
    height: 280px;
  }
  .title {
    margin-bottom: 8px;
    padding: 30px 0px;
    color: #fff;
    font-size: 20px;
    font-weight: 500;
  }
  .image img {
    width: 100%;
    height: auto;
    max-width: 100%;
    display: block;
    margin: 0 auto 0px;
    border-top-right-radius: 50px;
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
  </style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dispatch/DispatchTabs.vue